import React from 'react';
import { Card, CardContent, CardHeader, Typography } from '@material-ui/core';

const BoxComponent = ({ title, content }) => {
    return (
        <Card
            style={{
                borderRadius: '8px',
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
            }}
        >
            {title && (
                <CardHeader
                    title={
                        <Typography
                            variant="subtitle1"
                            color="primary"
                            style={{ fontWeight: 500, fontSize: '14px' }}
                        >
                            {title}
                        </Typography>
                    }
                    style={{
                        backgroundColor: '#fafafa',
                        borderBottom: '1px solid #eee',
                        padding: '8px 16px',
                    }}
                />
            )}
            <CardContent style={{ padding: '12px 16px' }}>
                <Typography
                    variant="body2"
                    style={{ color: '#666', fontSize: '13px', lineHeight: 1.5 }}
                >
                    {content}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default BoxComponent;

